// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2qxEl","rootSmall":"AddTileButton_rootSmall__3YyT6"};